<template>
    <a-modal
            :width="'50%'"
            v-model="editEntity"
            :title="$t('supervise.editEntity')"
            :maskClosable="maskClosable"
            @ok="handleOk"
            :destroyOnClose="true">

        <div style="padding:20px;">
            <a-card>
                <a-form :form="form">
                    <a-form-item :label="$t('supervise.superviseOrg')" v-bind="formItemLayout">
                        <z-org-chooser ref="orgChooser" :option="orgOption" @orgSelect="onOrgSelect"></z-org-chooser>
                    </a-form-item>

                    <a-form-item :label="$t('supervise.group')" v-bind="formItemLayout">
                        <a-select  v-model="groupId" size="small" v-decorator="['groupId',{ rules: [{ required: true, message: $t('global.isRequired') }] }] ">
                            <a-select-option v-for="group in groups" :key="group.groupId" >{{getGroupNames(group.groupName)}}</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item v-for="(item, index) in fields" :label="$t(`columnCheck.${item.name}`)" :key="index" v-bind="formItemLayout">
                        <a-input-number v-model="item.value" size="small" v-if="item.inputType == 'number'" style="width:100%"  v-decorator="item.isCrucial || item.isRequire ? [item.name,{ rules: [{ required: true, message: $t('global.isRequired') }] }] : [item.name,{ rules: null }]"></a-input-number>
                        <a-input v-model="item.value" size="small" v-if="item.inputType == 'text'"  v-decorator="item.isCrucial || item.isRequire ? [item.name,{ rules: [{ required: true, message: $t('global.isRequired') }] }] : [item.name,{ rules: null }]"></a-input>
                        <a-select  v-model="item.value" v-if="item.inputType == 'selectBox'" size="small" v-decorator="item.isCrucial || item.isRequire ? [item.name,{ rules: [{ required: true, message: $t('global.isRequired') }] }] :[item.name,{ rules: null }] ">
                            <a-select-option v-for="selectItem in item.dataSource.split(',')" :key="selectItem" >{{selectItem}}</a-select-option>
                        </a-select>
                        <a-date-picker v-model="item.value" size="small" v-if="item.inputType == 'date'" style="width:100%" v-decorator="item.isCrucial || item.isRequire ? [item.name,{ rules: [{ required: true, message: $t('global.isRequired') }] }] :[item.name,{ rules: null }]"></a-date-picker>
                        <UploadImage v-model="item.value" v-if="item.inputType === 'image'" />
                    </a-form-item>
                </a-form>
            </a-card>
        </div>
    </a-modal>
</template>

<script>
    import config from '@/config'
    import ZOrgChooser from '@/components/common/OrgChooser.vue'
    import UploadImage from '@/components/common/UploadImage'
    import moment from 'moment'

    export default {
        name: 'ZUpdateEntity',
        data() {
            return{
                showImg: false,
                maskClosable: false,
                editEntity: false,
                form: null,
                fields:[],
                groups: [],
                entityId : null,
                entity: null,
                groupId: null,
                orgId: null,
                orgOption:{
                    id: "updateEntityOrg",
                    value: ""
                },
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 4 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 },
                    }
                }
            }
        },
        components:{
            ZOrgChooser,
            UploadImage
        },
        methods:{
            onOrgSelect(org){
                this.orgId = org.id
                let _this = this
                this.$http.get(config.api.entity_group_summary_url + '/' + org.id).then((response) => {
                    if(response.code == 0){
                        // let tmpGroups = response.result
                        // tmpGroups.map(m=>{ 
                        //     return m.groupName = this.$t(`global.${m.groupName}`)
                        // })
                        this.groups = response.result 
                        // let isMatch = false
                        // this.groups.map(function(item){
                        //     if(_this.groupId == item.groupId){
                        //         isMatch = true
                        //         return
                        //     }
                        // })

                        // if(isMatch){
                        //     _this.form.setFieldsValue({
                        //         groupId:_this.groupId
                        //     });
                        // }else{
                        //     _this.groupId = org.defaultEntityGroupId
                        //     _this.form.setFieldsValue({
                        //         groupId:org.defaultEntityGroupId
                        //     });
                        // }
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
            getFields (id) {
                return new Promise((resolve) => {
                    // if(this.fields.length == 0){
                    this.$http.get(config.api.entity_template_org_url + "/" + id).then((response) => {
                        if(response.code == 0){
                            this.fields = response.result.attrs
                            resolve(response.result.attrs)
                        }
                    }).catch((err) => {
                        console.log(err)
                    })
                    // }
                })
            },
            handleOk(){
                this.form.validateFieldsAndScroll((err, values) => {
                    if (!err) {
                        let params = []
                        let param = {}
                        let attrs = {}
                        this.fields.map((item) => {
                            if(item.value && item.value != ''){
                                let attr = {}
                                if(item.inputType == 'date'){
                                  // console.log(typeof item.value)
                                  // debugger
                                    // attrs[item.name] = (item.value.valueOf()/1000).toFixed() + ''
                                    // 如果做了选择这里会得到一个moment对象
                                    // 如果没改变这里会得到一个秒级的时间戳
                                    attrs[item.name] = typeof item.value === 'string' ? item.value + '' : item.value.unix()
                                }else{
                                    attrs[item.name] = item.value + ''
                                }
                            } else if (item.value === '') {
                              attrs[item.name] = ''
                            }
                        })
                        param.id = this.entityId
                        param.orgId = this.orgId
                        param.groupId = this.groupId
                        param.attrs = attrs
                        params.push(param)
                        let _this = this
                        this.$http.put(config.api.entity_update_url,params).then((response) => {
                            if(response.code == 0){
                                // _this.$message.success('修改实体成功')
                                this.$notification.success({
                                  message: this.$t('global.commitSuccess')
                                })
                                _this.$emit('success');
                                _this.editEntity = false
                            }
                        }).catch((err) => {
                            console.log(err)
                        })
                    }
                })
            },
            showModel(entity){
                let _this = this
                _this.entity = entity
                this.editEntity = true
                console.log(entity)
                this.getFields(entity.orgId).then((res) => {
                    _this.fields.map(function(item){
                        item.value = _this.entity[item.name] ? _this.entity[item.name] : null
                    })
                    this.$nextTick().then(() => {
                        this.form.setFieldsValue({
                          groupId: entity.groupId
                        })
                        _this.fields.map(function(item){
                            if(item.inputType== 'date'){
                                if(item.name && item.value){
                                    let time = moment(item.value * 1000)
                                    _this.form.setFieldsValue({
                                        [item.name]:time
                                    });
                                }else {
                                    _this.form.setFieldsValue({
                                        [item.name]:null
                                    });
                                }
                            }else{
                                _this.form.setFieldsValue({
                                    [item.name]:item.value
                                });
                            }
                        })
                        if(this.$refs["orgChooser"]){
                            this.$refs["orgChooser"].initOrgTree(null,entity.orgId)
                        }
                    })

                    this.groupId = entity.groupId
                    this.entityId = entity.id
                })
            },
            getGroupNames(groupName){
                switch(groupName){
                    case '普管组':
                    case '宽管组':
                    case '严管组':
                    return this.$t(`global.${groupName}`)
                    default:
                    return groupName
                }
}
        },
        mounted() {
            this.form = this.$form.createForm(this)
        }
    }
</script>
